import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import RoundedAvatar from "../../waybee-ui/RoundedAvatar";

const AVATAR_SIZE = 64;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 0;
`;

const Name = styled.h2`
  font-family: Roboto;
  font-size: 22px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.secondary.dark};
  margin: 0 0 4px;
`;

const Info = styled.p`
  opacity: 0.5;
  font-family: Roboto;
  font-size: 16px;
  color: #000000;
  margin: 0;
`;

export default function OccurrencesHeader({ name, info, photo }) {
  return (
    <Container>
      <RoundedAvatar size={AVATAR_SIZE} imageSrc={photo}>
        {name}
      </RoundedAvatar>
      <div>
        <Name>{name}</Name>
        <Info>{info}</Info>
      </div>
    </Container>
  );
}

OccurrencesHeader.propTypes = {
  name: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  photo: PropTypes.string
};

OccurrencesHeader.defaultProps = {
  photo: null
};
